export default {
    auth: require('./auth'),
    core: require('./core'),
    bo: require('./bo'),
    store: require('./store'),
    contacts: require('./contacts'),
    components: require('./components'),
    tickets: require('./tickets'),
    categories: require('./categories'),
    exports: require('./exports'),
    billing: require('./billing'),
    vouchers: require('./vouchers'),
    general: require('./general'),
    guestlists: require('./guestlists'),
    passbooks: require('./passbooks'),
    picklists: require('./picklists'),
    'action-log': require('./action-log'),
    addressbook: require('./addressbook'),
    rsvps: require('./rsvps'),
    documents: require('./documents'),
    navigation: require('./navigation'),
    messages: require('./messages'),
    pos: require('./pos'),
    media: require('./media'),
    templates: require('./templates'),
    user: require('./user'),
    wallets: require('./wallets'),
    stats: require('./stats'),
    seatplans: require('./seatplans'),
    'merge-tags': require('./merge-tags')
}



// WEBPACK FOOTER //
// ./src/app/i18n/en/translations.js